import React, { useCallback, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { FormHelperText } from '@material-ui/core';
import { Controller } from 'react-hook-form';

type Props = {
  control: any;
  name: string;
  error?: string | null;
  required?: boolean;
  setValue: any;
  register: any;
  fieldClassName?: string;
  initialValue?: string;
};

const EditorField: React.FC<Props> = ({
  control,
  name,
  error,
  required,
  register,
  setValue,
  fieldClassName,
  initialValue,
}) => {
  const [editorValue, setEditorValue] = useState();
  const onEditorChange = useCallback((value:any) => {
    setEditorValue(value);
  }, []);
  return (
    <>
      <Controller
        name={name}
        control={control}
        onBlur={() => setValue(name, editorValue)}
        onEditorChange={onEditorChange}
        required={required}
        className={fieldClassName}
        as={
          <Editor
            ref={register}
            apiKey="k7w60w3aez6hesda4tem8lfr0l2i5lqpnx6vk34tmmdyb81z"
            init={{
              height: 300,
              menubar: false,
              plugins: [
                'advlist paste autolink lists link charmap print preview anchor',
                'searchreplace visualblocks fullscreen spellchecker',
                'insertdatetime media table paste code help wordcount',
              ],
              toolbar:
                'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | spellchecker help',
            }}
            initialValue={initialValue}
          />
        }
      />
      {error && <FormHelperText>{error}</FormHelperText>}
    </>
  );
};

EditorField.displayName = 'EditorField';

export default React.memo(EditorField);
